$.when( $.ready ).then(() => {
	//$('[data-toggle="popover"]').popover();
	$('[data-toggle="tooltip"]').tooltip();
});
